module.exports = __webpack_public_path__ + "img/bg_5.b90adec9.jpg";